<div class="tabs no-select">
    <div class="tab" *ngFor="let t of tabs; let i = index"
         [ngClass]="{active: tab == i}"
         (click)="tab = i"
    >{{ t }}</div>
</div>

<ng-container *ngIf="data && pages && tab == 0">
    <div>
        <select [(ngModel)]="perPage" (change)="perPageChanged($event.target.value)">
            <option>25</option>
            <option>50</option>
            <option>100</option>
            <option>150</option>
            <option>200</option>
        </select>
    </div>
    <br>

    <app-paginator [pages]="pages" [current]="current" (onChangePage)="changed($event)"></app-paginator>

    <div class="data-table">
        <app-table [table]="table" [full]="full" [primaryKey]="primaryKey" [dataSource]="data"
                   (onSearch)="onSearch($event)"></app-table>
    </div>

    <app-paginator [pages]="pages" [current]="current" (onChangePage)="changed($event)"></app-paginator>
</ng-container>

<ng-container *ngIf="tab == 1">
    <app-create-record [table]="table" [full]="full"></app-create-record>
</ng-container>
